import { Component, Input } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';
import { ApprovalStatusEnum } from 'src/app/services/enums/approval-status.enum';
import { HelpersService } from '@evento-ng/libs';
@Component({
  selector: 'app-order-item',
  templateUrl: './order-item.component.html',
  styleUrls: ['./order-item.component.scss'],
})
export class OrderItemComponent {
  @Input() order: any;
  @Input() event: any;
  ApprovalStatusEnum = ApprovalStatusEnum;

  constructor(
    public helpers: HelpersService,
    public translate: TranslateService
  ) {}
}
